import { render, staticRenderFns } from "./DialogPaoStructure.vue?vue&type=template&id=44c15680&scoped=true"
import script from "./DialogPaoStructure.vue?vue&type=script&lang=js"
export * from "./DialogPaoStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c15680",
  null
  
)

export default component.exports